module.exports = __webpack_public_path__ + "3872ded0a172c805a16f17ab56617a00.jpg";